import { CountryInterface } from '../../interfaces/create-surveys.interface';

export class LocaleFullNameMapper {
  constructor(
    private readonly _locales: string | string[],
    private readonly _countries: CountryInterface[]
  ) {}

  public map(): string | string[] {
    if (Array.isArray(this._locales)) {
      return this._locales.map((locale) => this._localeMapper(locale));
    }

    return this._localeMapper(this._locales);
  }

  private _localeMapper(locale: string): string {
    const [languageCode, countryCode] = locale.split('_');

    const matchedCountry = this._countries.find(
      (country) => country.short_Code === countryCode
    );

    if (!matchedCountry) {
      return locale;
    }

    const matchedLanguage = matchedCountry.lang.find(
      (language) => language.transalte_code === languageCode
    )!;
    return `${matchedCountry.name}-${matchedLanguage.name}`;
  }
}
